import { useState, useCallback } from 'react';

export interface ContextMenuState {
	open: boolean;
	position: { x: number; y: number };
}

export const useContextMenu = () => {
	const [state, setState] = useState<ContextMenuState>({
		open: false,
		position: { x: 0, y: 0 }
	});

	const handleContextMenu = useCallback((e: React.MouseEvent) => {
		e.preventDefault();
		e.stopPropagation();
		setState({ open: true, position: { x: e.clientX, y: e.clientY } });
	}, []);

	const close = useCallback(() => {
		setState((prev) => ({ ...prev, open: false }));
	}, []);

	return {
		open: state.open,
		position: state.position,
		handleContextMenu,
		close
	};
};
